<template>
  <fragment>
    <div class="properties">
      <div class="header">{{ $t('PROPERTIES_OF', { thing: name }) }}</div>
      <table class="ui very basic fixed single line table">
        <tbody>
          <tr v-for="(value, name) in properties" :key="name">
            <td class="name" :title="name">
              {{ name }}
            </td>
            <td class="value monospaced" :title="JSON.stringify(value, null, 2)">
              {{ value }}
            </td>
            <td class="actions">
              <div
                class="mini icon button"
                @click="showModal(name, value)"
                v-if="value && JSON.stringify(value).length > 20"
              >
                <i class="external link square alternate icon" />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <portal to="modals">
      <modal
        :ctrl="modal"
        :positiveLabel="{
          text: $t('OK'),
          icon: 'run'
        }"
      >
        <div ref="modalEditor" style="height: 300px;"></div>
      </modal>
    </portal>
  </fragment>
</template>

<style lang="scss" scoped>
.properties {
  min-width: 250px;
  max-width: 400px;

  td.name {
    width: 100px;
  }

  td.value {
    max-width: 240px;
  }

  td.actions {
    width: 40px;
  }

  .header {
    text-transform: uppercase;
    font-size: 0.8em;
    font-weight: bold;
  }
}
</style>

<script>
import _ from 'lodash'
import { Modal, ModalController } from 'ui'
import { Fragment } from 'vue-frag'
import * as monaco from 'monaco-editor/esm/vs/editor/editor.api' // needs to be imported this way in order to include only subset of languages

export default {
  name: 'Properties',
  components: { Modal, Fragment },

  props: {
    of: {
      type: Object
    },
    name: {
      type: String
    },
    ignore: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      modal: new ModalController(),
      monacoModel: null,
      editor: null
    }
  },

  computed: {
    properties() {
      if (!this.of) {
        return {}
      }
      return _.omitBy(this.of, (value, name) => {
        return _.find(this.ignore, ignore => new RegExp(ignore).test(name))
      })
    }
  },

  methods: {
    showModal(name, value) {
      this.modal.show()
      if (this.editor == null) {
        this.monacoModel = monaco.editor.createModel('', 'json', monaco.Uri.parse('a://b/foo.json'))
        this.editor = monaco.editor.create(this.$refs.modalEditor, {
          model: this.monacoModel,
          readOnly: true,
          minimap: {
            enabled: false
          }
        })
      }

      this.modal.header = _.upperFirst(name)
      this.editor.setValue(JSON.stringify(value, null, 2))
    }
  },

  mounted() {}
}
</script>
